import {
  FETCH_DASHBOARD_STATS_REQUEST,
  FETCH_DASHBOARD_STATS_SUCCESS,
  FETCH_DASHBOARD_STATS_FAILURE,
  FETCH_TODAY_ATTENDANCE_REQUEST,
  FETCH_TODAY_ATTENDANCE_SUCCESS,
  FETCH_TODAY_ATTENDANCE_FAILURE,
  FETCH_ATTENDANCE_BY_DESIGNATION_REQUEST,
  FETCH_ATTENDANCE_BY_DESIGNATION_SUCCESS,
  FETCH_ATTENDANCE_BY_DESIGNATION_FAILURE,
} from "../actions/dashboardActions";

const initialState = {
  stats: {},
  attendance: [],
  designationAttendance: [],
  loading: false,
  error: null,
};

const dashboardReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_DASHBOARD_STATS_REQUEST:
    case FETCH_TODAY_ATTENDANCE_REQUEST:
    case FETCH_ATTENDANCE_BY_DESIGNATION_REQUEST:
      return { ...state, loading: true, error: null };

    case FETCH_DASHBOARD_STATS_SUCCESS:
      return { ...state, loading: false, stats: action.payload };

    case FETCH_TODAY_ATTENDANCE_SUCCESS:
      return { ...state, loading: false, attendance: action.payload };

    case FETCH_ATTENDANCE_BY_DESIGNATION_SUCCESS:
      return { ...state, loading: false, designationAttendance: action.payload };

    case FETCH_DASHBOARD_STATS_FAILURE:
    case FETCH_TODAY_ATTENDANCE_FAILURE:
    case FETCH_ATTENDANCE_BY_DESIGNATION_FAILURE:
      return { ...state, loading: false, error: action.payload };

    default:
      return state;
  }
};

export default dashboardReducer;
